export const VoucherOptionValues = {
  FULL: 'FULL_VOUCHER',
  PARTIAL: 'PARTIAL_VOUCHER',
} as const

export type VoucherOption = (typeof VoucherOptionValues)[keyof typeof VoucherOptionValues]
export type VoucherScreen = 'redeem' | 'options' | 'unusable' | 'success'

export const VoucherCannotBeUsedReasonValues = {
  EXPIRED: 'Expired',
  IS_VOID: 'IsVoid',
  NO_BALANCE: 'NoBalance',
} as const

export type VoucherCannotBeUsedReason = typeof VoucherCannotBeUsedReasonValues[keyof typeof VoucherCannotBeUsedReasonValues]

export interface VoucherFormValues {
  voucherCode: string
  email: string
  birthdate: string
}

export interface VoucherType {
  voucherCode: string
  email: string
  birthdate: string
  expirationDate: string
  isActive: boolean
  canBeUsed: boolean
  cannotBeUsedReasons: string[]
  amountText: string
  amount: number
  currencySymbol: string
  bonusAmountLabel?: string
  bonusLabel?: string
}

export interface AmountsType {
  amount: number
  restAmount: number
}

export interface VoucherAmountsType {
  totalAmount: number
  transactionAmount: number
  remainingAmount: number
}

export interface VoucherApplyResult {
  isVoucherFullyRedeemed: boolean
  isBookingFullyPaid: boolean
  isBookingDepositPaid: boolean
  booking: AmountsType
  deposit: AmountsType
  voucher: VoucherAmountsType
  urlRedirect?: string
}

export interface VoucherState {
  screen: VoucherScreen
  genericError: boolean
  checkLoading: boolean
  voucher: VoucherType | null
  applyLoading: boolean
  applyError: boolean
  applyResult: VoucherApplyResult | null
  selectedVoucherIsOwned: boolean
}

export interface VoucherStore extends VoucherState {
  reset: () => void
}

export const initialVoucherState: VoucherState = {
  screen: 'redeem',
  genericError: false,
  checkLoading: false,
  voucher: null,
  applyLoading: false,
  applyError: false,
  applyResult: null,
  selectedVoucherIsOwned: false,
}
